import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cxo-placement/artifacts/o33cdnbv_profile_pic.png";

export const Footer = () => {
  return (
    <footer className="footer-bg text-white py-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img src={LOGO_URL} alt="Ratnatrraya" className="h-12 w-12 object-contain" />
              <div className="font-secondary">
                <span className="text-2xl font-bold block leading-tight">Ratnatrraya</span>
                <span className="text-lg font-light">Consulting</span>
              </div>
            </Link>
            <div className="text-slate-300 mb-6 space-y-1">
              <p>Right Vision.</p>
              <p>Right Knowledge.</p>
              <p>Right Action.</p>
            </div>
            <p className="text-slate-400 text-sm mb-6">For micro businesses: Accounting + Compliance + Micro CFO support</p>
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/company/ratnatrrayaconsulting/" target="_blank" rel="noopener noreferrer" className="p-2 bg-slate-800 rounded-lg hover:bg-slate-700 transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Services</h4>
            <ul className="space-y-3 text-slate-400">
              <li><Link to="/ccfs-2026-company-status-check" className="hover:text-white transition-colors text-[#E84C3D]">Company Reset</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Accounting & Bookkeeping</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Tax & Compliance</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Registration Services</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Micro CFO</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">CXO Hiring</Link></li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Company</h4>
            <ul className="space-y-3 text-slate-400">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/team" className="hover:text-white transition-colors">Our Team</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/r-pace-partner-login" className="hover:text-white transition-colors">Partner Login</Link></li>
              <li><Link to="/admin/login" className="hover:text-white transition-colors text-slate-500 text-xs">Admin</Link></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Contact</h4>
            <ul className="space-y-4 text-slate-400">
              <li className="flex items-start gap-3">
                <Mail size={20} className="text-[#E84C3D] shrink-0 mt-0.5" />
                <span>support@ratnatrraya.consulting</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-[#E84C3D] shrink-0 mt-0.5" />
                <span>Hyderabad, Mumbai, India</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-slate-700 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-slate-500 text-sm">
              &copy; {new Date().getFullYear()} Ratnatrraya Consulting LLP. All rights reserved.
            </p>
            <p className="text-slate-600 text-xs mt-1">
              Legal & Secretarial Services: <a href="https://samistilegal.in/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Samisti Legal</a>
            </p>
          </div>
          <div className="flex gap-6 text-sm text-slate-500">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
